import * as React from "react";
import {history} from "load/store";
import {imageBaseUrl} from "config";
import {RouteComponentProps} from "react-router-dom";
import "./index.scss";

interface IProps {
    children: React.ReactNode;
    pageTitle?: string;
    showBackButton?: boolean;
}

export const ConsentBox = (props: IProps & RouteComponentProps) => {
    const isAndroid = window.location.href.includes("android");
    const boxStyle = {
        color: "#000000",
        backgroundColor: "#F5F6FA",
        maxWidth: !isAndroid ? 450 : "calc(100vw)",
        border: !isAndroid && window.screen.width > 450 ? "1px solid #ACACAC" : "0px",
        minHeight: isAndroid ? "100vh" : "calc(100vh - 121px)",
        padding: 22,
        marginLeft: -15,
        marginRight: -15,
    };
    return (
        <div className="consent-box" style={boxStyle}>
            {props.pageTitle ?
                <div className="title-container">
                    {props.showBackButton ?
                        <div className="icon" onClick={() => history.goBack()}>
                            <img src={`${imageBaseUrl}/img/consent/back_arrow.png`}/>
                        </div> : null}
                    <div className="title">
                        {props.pageTitle}
                    </div>
                </div>
                : null}
            {props.children}
        </div>
    );
};

export default ConsentBox;
